<template>
  <b-card no-body>
    <b-card-body>
      <customer-parameter-detail
        ref="customerParameterDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerParameterDetail from '@/views/pages/customers/CustomerParameterDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerParameterDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },

  created() {
    const parameterId = this.$route.params.parameter_id;
    this.id = parameterId;
    this.getParameterData(this.id);
  },
  methods: {
    submit(data) {
      this.submitting = true;

      const request = {
        value: data.value
      };

      const id = this.$route.params.parameter_id;

      useService
        .editCustomerParameter(id, request)
        .then(response => {
          // this.$refs.customerUserDetail.resetForm()
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'customers_parameters_list',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getParameterData(id) {
      this.submitting = true;
      useService
        .getParameter(id)
        .then(response => {
          this.data = response.data;

          const { description, type, key, value } = response.data;

          this.data = {
            description,
            type,
            key,
            value
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
